import Progress from 'antd/lib/progress';
import * as React from 'react';
import { runwayColors } from '../styles/globalStyles';
import { calculatePercentComplete, isDoneTranslationStatus } from '@/helpers';
import { getRelevantTranslationStrings } from '@/components/StepContentSubmission/helpers';
import { TranslationString } from '@/types';

interface PercentTranslationsCompleteComponentProps {
    workingBranchEnabled: boolean;
    releaseId: string;
    keys: TranslationString[];
    workingBranchKeys: TranslationString[];
}

const PercentTranslationsCompleteComponent: React.FC<PercentTranslationsCompleteComponentProps> = (
    props: PercentTranslationsCompleteComponentProps,
) => {
    const percentComplete = React.useMemo(() => {
        const allStrings = getRelevantTranslationStrings(
            props.workingBranchEnabled,
            props.workingBranchKeys,
            props.keys,
        );
        const completedStrings = allStrings.filter((s) => isDoneTranslationStatus(s.status));
        return calculatePercentComplete(completedStrings.length, allStrings.length);
    }, [props.workingBranchEnabled, props.workingBranchKeys, props.keys]);

    return (
        <Progress
            type="circle"
            strokeColor={runwayColors.statusGreen}
            percent={percentComplete}
            format={(percent) => {
                return `${percent}%`;
            }}
        />
    );
};

export default PercentTranslationsCompleteComponent;
